export type FileFocus = { conversation: string; file: string } | null;

export function focusFrom(path: string): FileFocus {
  const url = new URL(path, "http://rally.local");
  const conversation = /^\/c\/([\w-]+)$/.exec(url.pathname)?.[1];
  const file = url.searchParams.get("focus");
  return conversation && file ? { conversation, file } : null;
}

export function enterFileFocus(path: string, conversation: string, file: string): string {
  const url = new URL(path, "http://rally.local");
  url.pathname = `/c/${conversation}`;
  url.searchParams.set("file", file);
  url.searchParams.set("focus", file);
  return `${url.pathname}${url.search}`;
}

export function collapseFileFocus(path: string): string {
  const url = new URL(path, "http://rally.local");
  url.searchParams.delete("focus");
  return `${url.pathname}${url.search}`;
}

export function focusIsHere(focus: FileFocus, conversation: string, card: string | null): boolean {
  return focus?.conversation === conversation && card === `file:${focus.file}`;
}

export function focusMetadata(size: string, facts: readonly string[], medium: boolean): string {
  return [size, ...(medium ? [] : facts)].join(" · ");
}

export function commentsAreDrawn(focused: boolean, open: boolean): boolean {
  return !focused || open;
}

export function fileSourcePath(conversation: string, message: string | null): string {
  return message ? `/c/${conversation}?${new URLSearchParams({ message })}` : `/c/${conversation}`;
}
